import { useId } from 'react';
import type { InboundIntegration } from '../../services/tenantApi';

export function WorkflowInboundIntegrationSelect({ value, integrations, disabled, onChange }: {
  value: string;
  integrations: InboundIntegration[];
  disabled?: boolean;
  onChange: (value: string) => void;
}) {
  const id = useId();
  return <div className="form-group">
    <label htmlFor={id}>Inbound Integration</label>
    <select id={id} value={value} disabled={disabled} onChange={event => onChange(event.target.value)}>
      <option value="">Global / legacy (no association)</option>
      {value && !integrations.some(item => item.inboundIntegrationId === value) &&
        <option value={value}>Unavailable integration ({value})</option>}
      {integrations.map(integration => <option key={integration.inboundIntegrationId} value={integration.inboundIntegrationId}>
        {integration.name} ({integration.nonAlert ? 'Notification' : 'Alert'}{integration.isEnabled ? '' : ', disabled'})
      </option>)}
    </select>
  </div>;
}
